import React from 'react';
import location from "./../../../../Images/minilocation.png";
import msg from "./../../../../Images/minimsg.png";
import web from "./../../../../Images/miniweb.png";
import phn from "./../../../../Images/miniphn.png";
import Twitter from "./../../../../Images/XCollectionIcon.png";
import Insta from "./../../../../Images/instaCollectionIcon.png";
import LinkedIn from "./../../../../Images/linkedincollectionicon.png";
import Facebook from "./../../../../Images/facbookCollectionicon.png";
import ExtAlternateUrls from './ExtAlternateUrls.js'
import { useTranslation } from "react-i18next";
import { getServicesArray } from '../../../../utils/utility.js';



 const ContactInfo = (props) => {
   const { t } = useTranslation();
  let usefulLinks = props?.contdata?.onState?.alternateurl;
  const getBrandNameForSocial = (brand) => {
    if (brand == "gmail") {
      return "google";
    } else return `${brand}`;
  };

  return (
    <div>
      {props?.contdata && (
        <div className='ExtContactInfoMini  pt-3'>
        
            <div className='flex items-start'>
                <div className='z-0  rounded-2xl w-5'>
                <i class="fa-solid fa-phone" style={{color:`${props?.colordata?.dynamicCtaColor}` || '', background:`${props?.colordata?.dynamicCtaColor}52`}}></i>
                </div>
               <div>
               <div className='mx-2' style={{color: props?.colordata?.dynamicTextHeadingColor ? `${props?.colordata?.dynamicTextHeadingColor}`:''}}> {props?.contdata?.contactInfo?.contactInfoPhone}</div>
                {/* <div className='mx-2' style={{color: props?.colordata?.dynamicTextHeadingColor ? `${props?.colordata?.dynamicTextHeadingColor}` : ''}}> {props?.contdata?.contactInfo?.optionalContactInfoPhone}</div> */}
                          </div>
                </div>
            {props?.contdata?.contactInfo?.contactInfoWebUrl && 
            <div className='flex items-center'>
                <div className='z-0  rounded-2xl w-5'>
                <i class="fa-solid fa-globe" style={{color:`${props?.colordata?.dynamicCtaColor}` || '', background:`${props?.colordata?.dynamicCtaColor}52`}}></i>
                </div>
                <div className='mx-2' style={{color: props?.colordata?.dynamicTextHeadingColor ? `${props?.colordata?.dynamicTextHeadingColor}` : ''}}>{props?.contdata?.contactInfo?.contactInfoWebUrl}</div>
            </div>
          }
            <div className='flex items-center'>
                <div className='z-0  rounded-2xl w-5'>
                 <i class="fa-solid fa-envelope" style={{color:`${props?.colordata?.dynamicCtaColor}` || '', background:`${props?.colordata?.dynamicCtaColor}52`}}></i>
                </div>
                <div className='mx-2' style={{color: props?.colordata?.dynamicTextHeadingColor ? `${props?.colordata?.dynamicTextHeadingColor}` : ''}}>  {props?.contdata?.contactInfo?.contactInfoEmail}</div>
            </div>
            {props?.contdata?.contactInfo?.contactInfoAddress && 
            <div className='flex items-center'>
                <div className='z-0  rounded-2xl w-5'>
                 <i class="fa-solid fa-location-dot" style={{color:`${props?.colordata?.dynamicCtaColor}` || '', background:`${props?.colordata?.dynamicCtaColor}52`}} ></i>
                </div>
                <div className='mx-2' style={{color: props?.colordata?.dynamicTextHeadingColor ? `${props?.colordata?.dynamicTextHeadingColor}` : ''}}>{props?.contdata?.contactInfo?.contactInfoAddress}</div>
            </div>
 }
            {props?.contdata?.contactInfo?.contactInfoOptAddress && 
            <div className='flex items-center'>
                <div className='mx-2' style={{paddingLeft:"26px", color:`${props?.colordata?.dynamicTextHeadingColor}B3` || '#936f5e'}}>
          <p style={{color:`${props?.colordata?.dynamicTextHeadingColor || 'gray'}70`, fontSize:"12px", fontWeight: "500", margin:"0"}}>{t("Alternative_address")}</p>
          <span style={{color:`${props?.colordata?.dynamicTextHeadingColor}` || 'black'}}>{props?.contdata?.contactInfo?.contactInfoOptAddress}</span> </div>
          </div>
            }
        </div>
        )}
      <div>

        { props?.contdata?.onState?.realEstateServices && (
                  <article className="realEstateServices"  style={{backgroundColor: props?.dynamicBackgroundColor || "" }}>
                    <h3 class="specialization" style={{color: props?.dynamicTextDescriptionColor || "" }}>{props?.serviceHeading || t("Specialization")} </h3>
                    <div className="mainservicebox realEstateServiceList mt-3">
                      {props?.contdata?.servicesArray && (
                        <ul className="servesbox">
                          {getServicesArray(props?.contdata?.servicesArray).map(
                            (val) =>
                              val?.name != null && <li key={val?.name} className="service-list" style={{  color: props?.dynamicTextDescriptionColor || "#123463" ,  background:props?.dynamicCtColor ? `${props?.dynamicCtColor}1a` : "#1234631a" }}> {val?.name}</li>
                          )}
                        </ul>
                      )}
                    </div>
                  </article>
                )}

        { props?.contdata?.onState?.businessHours && (
          <article className="businessHours_sec internalbusinessstyle realEstateServices  " >
            <h3 class="specialization" style={{color: props?.dynamicTextDescriptionColor || "" }}>{props?.businessHourHeading || t("Working_hours")}</h3>

            <ul class="timelist realEstateServiceList mt-3">
              {props?.contdata?.businessHourObject?.isMonday &&
                props?.contdata?.businessHourObject?.modayStartDate &&
                props?.contdata?.businessHourObject?.modayEndDate && (
                  <li>
                    <div className="day" style={{color: props?.dynamicTextDescriptionColor ?  `${props?.dynamicTextDescriptionColor}90` : "#123463" }}>{t("Monday")}</div>
                    <div className="time">
                      {" "}
                      <span style={{color:props?.dynamicTextDescriptionColor ?  `${props?.dynamicTextDescriptionColor}90` : "#123463" }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.modayStartDate
                        )} -
                      </span>{" "}
                     
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463" }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.modayEndDate
                        )}
                      </span>
                    </div>
                  </li>
                )}
              {props?.contdata?.businessHourObject?.isTuesday &&
                props?.contdata?.businessHourObject?.tuesdayStartDate &&
                props?.contdata?.businessHourObject?.tuesdayEndDate && (
                  <li>
                    <div className="day" style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>{t("Tuesday")}</div>
                    <div className="time">
                      {" "}
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.tuesdayStartDate
                        )} -
                      </span>{" "}
                  
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.tuesdayEndDate
                        )}
                      </span>
                    </div>
                  </li>
                )}
              {props?.contdata?.businessHourObject?.isWednesDay &&
                props?.contdata?.businessHourObject?.wednesdayStartDate &&
                props?.contdata?.businessHourObject?.wednesdayEndDate && (
                  <li>
                    <div className="day" style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>{t("Wednesday")}</div>
                    <div className="time">
                      {" "}
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.wednesdayStartDate
                        )} -
                      </span>{" "}
                 
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463" }}> 
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.wednesdayEndDate
                        )}
                      </span>
                    </div>
                  </li>
                )}
              {props?.contdata?.businessHourObject?.isthrusdayDay &&
                props?.contdata?.businessHourObject?.thrusdayStartDate &&
                props?.contdata?.businessHourObject?.thrusdayEndDate && (
                  <li>
                    <div className="day" style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>{t("Thursday")}</div>
                    <div className="time">
                      {" "}
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.thrusdayStartDate
                        )} -
                      </span>{" "}
                 
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.thrusdayEndDate
                        )}
                      </span>
                    </div>
                  </li>
                )}
              {props?.contdata?.businessHourObject?.isfridayDay &&
                props?.contdata?.businessHourObject?.fridayStartDate &&
                props?.contdata?.businessHourObject?.fridayEndDate && (
                  <li>
                    <div className="day" style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>{t("Friday")}</div>
                    <div className="time">
                      {" "}
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463" }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.fridayStartDate
                        )} -
                      </span>{" "}
                      
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.fridayEndDate
                        )}
                      </span>
                    </div>
                  </li>
                )}
              {props?.contdata?.businessHourObject?.issaturdayDay &&
                props?.contdata?.businessHourObject?.SaturdayStartDate &&
                props?.contdata?.businessHourObject?.SaturdayEndDate && (
                  <li>
                    <div className="day" style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>{t("Saturday")}</div>
                    <div className="time">
                      {" "}
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463" }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.SaturdayStartDate
                        )} -
                      </span>{" "}
                    
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.SaturdayEndDate
                        )}
                      </span>
                    </div>
                  </li>
                )}
              {props?.contdata?.businessHourObject?.issundayDay &&
                props?.contdata?.businessHourObject?.SundayStartDate &&
                props?.contdata?.businessHourObject?.SundayEndDate && (
                  <li>
                    <div className="day" style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463" }}>{t("Sunday")}</div>
                    <div className="time">
                      {" "}
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463"  }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.SundayStartDate
                        )} -
                      </span>{" "}
                   
                      <span style={{color: props?.dynamicTextDescriptionColor ? `${props?.dynamicTextDescriptionColor}90` : "#123463" }}>
                        {props?.contdata?.changeTimeFormat(
                          props?.contdata?.businessHourObject?.SundayEndDate
                        )}
                      </span>
                    </div>
                  </li>
                )}
            </ul>
          </article>
        )}
       
      <div style={{background:props?.colordata?.dynamicMainBackgroundColor }}   className={`px-1 py-4 pb-0 spacing -bottom-25 w-full text-center ${
        props?.colordata?.dynamicMainBackgroundColor ? "" : "bg-white"}`}>
     
      {props?.contdata?.onState?.socials && (
         <>
         <div className='flex justify-start items-center'>
      <div className='Useful_Links' >
        <div className='ul_title specialization'  style={{color:props?.colordata?.dynamicTextHeadingColor || ''}}>{props?.contdata?.socialHeading || t("Social_links")}</div>
        </div>
      </div>
       <div className='flex items-center justify-evenly  py-2 w-hundred' style={{color:props?.colordata?.dynamicTextHeadingColor || '#FF6933'}} >
       <ul class="socil-link  w-hundred"  >
       {props?.contdata?.socialMediaData?.map(
                (val) =>
                  val.link &&
                  getBrandNameForSocial(val.nameOfSocial.toLowerCase()) && (
                    <div className="social-link-container">
                      <li className="" key={val.link}>
                      <a>
                       
                        <i
                        style={{color:props?.colordata?.dynamicCtaColor || ''}}
                          className={`fa-${
                            val?.nameOfSocial.toLowerCase() === "star"
                              ? "solid"
                              : "brands"
                          } fa-${getBrandNameForSocial(
                            val?.nameOfSocial.toLowerCase()
                          )}`}
                        ></i>
                      </a>
                    </li>
                    </div>
                  )
              )}
        </ul>
       </div>
        </>
       )}
               {/* <div>
               <button className='bg-coffee text-xl rounded text-white w-full font-bold font-Tajawal pt-3  p-2 '
                 >
                   Contact supplier
                 </button>
               </div> */}
        </div>

        {usefulLinks && (
             
             <div className='Useful_Links'>
                <div  className='ul_title specialization' style={{marginBottom:"10px",color:props?.colordata?.dynamicTextHeadingColor || ''}}>{props?.contdata?.alternateUrlsHeading || t("Useful_links")}</div>
                <ExtAlternateUrls contdata={props?.contdata?.alternateUrlArray}  colordata={props?.colordata}/>
             </div>
            ) }

      </div>
    </div>
  )
}

export default ContactInfo;